module.exports = __webpack_public_path__ + "Roboto-Thin-webfont.8d613c0411f8c4e616a2.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/mac-jeremy/Projets/fairepart/src/assets/fonts/roboto/roboto_thin_macroman/Roboto-Thin-webfont.ttf
// module id = ../../../../../src/assets/fonts/roboto/roboto_thin_macroman/Roboto-Thin-webfont.ttf
// module chunks = 1